/*
 * Copyright (c) 2023 Bluemate B.V.
 */

import {generateComponentId} from '@dvrd/dvr-controls';

type RegisteredPopup = {
    id: string;
    handler: VoidFunction;
};
const activePopups: Set<string> = new Set();
const waitingPopups: Array<RegisteredPopup> = [];

export function requestOpenPopup(handler: VoidFunction, force: boolean = false): string {
    const popupId = generateId();
    const canOpen = force || !activePopups.size;
    if (canOpen) {
        activePopups.add(popupId);
        handler();
    } else {
        waitingPopups.push({id: popupId, handler});
    }
    return popupId;
}

export function onPopupClosed(popupId: string) {
    activePopups.delete(popupId);
    openNext();
}

export function cancelPopup(popupId: string) {
    if (!popupId) return; // Initially mounted popups don't have an ID yet
    for (let i = 0; i < waitingPopups.length; i++) {
        if (waitingPopups[i].id === popupId) {
            waitingPopups.splice(i, 1);
            return;
        }
    }
}

function openNext() {
    if (activePopups.size || !waitingPopups.length) return;
    const nextPopup = waitingPopups.shift();
    if (!nextPopup) return;
    activePopups.add(nextPopup.id);
    nextPopup.handler();
}

function generateId(): string {
    let popupId = generateComponentId();
    while (activePopups.has(popupId)) popupId = generateComponentId();
    return popupId;
}
